module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_7.29ea8f63.png";